// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"4ffc6992","206":"0d88e220","361":"3f9d3549","504":"187080ec","633":"2558a16c","657":"9a0750b0"}[chunkId] + ".chunk.js";
};